import React from 'react'
import {compose} from 'redux'
import {Grid, Typography} from '@material-ui/core'
import {withStyles} from '@material-ui/core/styles'
import HowItWorksImage from '../../assets/howItWorks.svg'

const styles = theme => ({
  component: {
    marginTop: 52,
    paddingBottom: 33,
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      backgroundColor: '#fafafa',
    },
  },
  mainContainer: {
    maxWidth: '940px !important',
    margin: '0 auto',
  },
  textContainer: {
    position: 'relative',
  },
  textDiv: {
    position: 'absolute',
    top: '50%',
    '-ms-transform': 'translateY(-50%)',
    transform: 'translateY(-50%)',
    [theme.breakpoints.down('sm')]: {
      '-ms-transform': 'translateY(0%)',
      transform: 'translateY(0%)',
      position: 'static',
    },
  },
  mainTitle: {
    display: 'block',
    fontWeight: 600,
    color: '#313131',
    textAlign: 'left',
    paddingLeft: '65px',

    [theme.breakpoints.down('sm')]: {
      padding: '30px 25px 0 25px',
      textAlign: 'center',
    },
  },
  sectionText: {
    fontSize: 16,
    fontWeight: 500,
    color: '#767676',
    paddingLeft: '65px',
    minHeight: 70,
    textAlign: 'left',

    [theme.breakpoints.down('sm')]: {
      padding: '0 25px 0 25px',
      textAlign: 'center',
    },
  },
  button: {
    backgroundColor: '#4573C4',
    borderRadius: '22px',
    fontWeight: '600',
    padding: '7px 66px',
    marginTop: '4em',
    letterSpacing: '1px',
    '& a': {
      color: 'white',
      textDecoration: 'none !important',
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: '23px',
    },
  },
})

class HowItWorks extends React.Component {
  render() {
    const {classes} = this.props

    return (
      <div className={classes.component}>
        <Grid container className={classes.mainContainer}>
          <Grid item md={5} xs={12}>
            <img className={classes.hideSmall} src={HowItWorksImage} width="100%" />
          </Grid>
          <Grid item md={7} xs={12} className={classes.textContainer}>
            <div className={classes.textDiv}>
              <Typography component="h4" variant="h4" className={classes.mainTitle}>
                An Affiliate Commerce Solution Managed By Professionals{' '}
              </Typography>
              <br />
              <Typography component="p" className={classes.sectionText}>
                Affiliate Marketing is complex and multifaceted. Multiple affiliate networks and
                competing priorities make it challenging for publishers to successfully launch &
                manage their own affiliate marketing.
              </Typography>
            </div>
          </Grid>
        </Grid>
      </div>
    )
  }
}

HowItWorks.displayName = 'HowItWorks'

export default compose(withStyles(styles))(HowItWorks)
